import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../../actions';
import API from '../../../apis';

export const getCheckoutsArchive = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkoutsArchive
        .fetchCheckoutsArchive(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CHECKOUT_ARCHIVE_FAILED,
              reject: actionTypes.GET_CHECKOUT_ARCHIVE_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CHECKOUT_ARCHIVE_LOADING);
  const success = res => action(actionTypes.GET_CHECKOUT_ARCHIVE_SUCCESS, res);

  return request();
};

export const getReservesCheckoutArchive = (checkoutWithCafeId, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkoutsArchive
        .fetchReservesCheckoutById(checkoutWithCafeId, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_FAILED,
              reject: actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_LOADING);
  const success = res => action(actionTypes.GET_RESERVES_CHECKOUT_ARCHIVE_SUCCESS, res);

  return request();
};

export const getCheckoutArchiveDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.checkoutsArchive
        .fetchCheckoutArchiveDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_FAILED,
              reject: actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_LOADING);
  const success = res => action(actionTypes.GET_CHECKOUT_ARCHIVE_DETAILS_SUCCESS, res);

  return request();
};
